<template>
  <div class="role-info-content">
    <div class="role-info-title flex-box">
      <div class="margin_right_24 role-detail-headline">权限设置</div>
      <div class="flex-box">
        <div class="role-info-switch">
          <el-switch
              v-model="roleInfoData.status"
              :disabled="currentStatus === 'system' || currentStatus === 'add'"
              :active-value="1"
              :inactive-value="2"

              @change="statusValueChange"
          >
          </el-switch>
        </div>
        <div v-if="roleInfoData.status === 1">已开启</div>
        <div v-else>已禁用</div>
      </div>
    </div>
    <div class="role-info-detail">
      <div class="role-detail-inner">
        <div class="role-basic-panel">
          <div class="role-panel-caption">基本信息</div>
          <div class="flex-box margin_bottom_12 field-row">
            <div class="margin_right_24 field-label">角色名称</div>
            <div>
              <el-input
                  :disabled="currentStatus === 'system' || currentStatus === 'user'"
                  class="input"
                  v-model="roleInfoData.roleName"
                  placeholder="请输入角色名称"
              ></el-input>
            </div>
          </div>
          <div class="flex-box margin_bottom_12 field-row">
            <div class="margin_right_24 field-label">角色说明</div>
            <div>
              <el-input
                  :disabled="currentStatus === 'system' || currentStatus === 'user'"
                  class="input"
                  v-model="roleInfoData.roleDesc"
                  placeholder="请输入角色说明"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="authorization-list">
          <div class="role-panel-caption">权限列表</div>
          <div class="authorization-tree-wrap">
            <el-tree
                ref="roleTree"
                :data="treeList"
                :show-checkbox="true"
                node-key="id"
                :default-expanded-keys="[0, 8]"
                :default-checked-keys="roleTreeList"
                :expand-on-click-node="false"
            >
              <div slot-scope="{ data }">
                {{ data.title }}
              </div>
            </el-tree>
          </div>
        </div>
      </div>
    </div>
    <div class="role-info-footer" v-if="currentStatus !== 'system'">
      <div v-if="currentStatus === 'add'" class="role-info-footer-btns">
        <el-button class="role-btn-ghost" @click="cancelAddRole">取消</el-button>
        <el-button type="primary" class="role-btn-primary" @click="addRoleHandle">保存</el-button>
      </div>
      <div v-if="currentStatus === 'user'" class="role-info-footer-btns">
        <el-button type="primary" class="role-btn-primary" @click="editRoleDetail">编辑</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoleInfoContent",
  props: {
    roleInfoData: {
      type: Object,
      default: () => {
        return {
          roleDesc: "",
          roleName: "",
          roleScope: 1,
          status: 1
        };
      }
    },
    currentStatus: {
      type: String,
      default: "user"
    },
    roleTreeList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    roleTreeList(val) {
      this.$refs.roleTree.setCheckedNodes(val);
    },
    currentStatus() {
      this.convertTreeData();
    }
  },
  data() {
    return {
      /**
       * 将查询的全量权限数据放在 children 中，直接使用tree的父节点全选效果
       * 提交时，将这个节点的id从数组中去除
       */
      treeList: [
        {
          id: 0,
          title: "全选",
          children: [],
          disabled: false
        }
      ]
    };
  },
  methods: {

    /**
     * 获取权限全量数据，
     */
    getAllTreeData() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/api/get_func_trees") .then(res => {
        console.log(res.data)
        if (res.data) {
          this.treeList[0].children = res.data.data.data;
          this.convertTreeData();
        }
      });
    },
    statusValueChange(val) {
      this.$emit("statusValueChange", val);
    },
    /**
     * 在状态为 "user" 或者 "system" 时，选线列表树的checkbox灰化
     */
    // convertTreeData() {
    //   this.setTreeCheckStatus(false);
    //   if (this.currentStatus === "user" || this.currentStatus === "system") {
    //     this.setTreeCheckStatus(true);
    //   } else if (this.currentStatus === "add") {
    //     this.treeList[0].children[0].disabled = true;
    //   }
    // },
    // setTreeCheckStatus(status) {
    //   for (let itemIndex in this.treeList) {
    //     this.treeList[itemIndex].disabled = status;
    //     if (this.treeList[itemIndex].children && this.treeList[itemIndex].children.length) {
    //       for (let childIndex in this.treeList[itemIndex].children) {
    //         this.treeList[itemIndex].children[childIndex].disabled = status;
    //       }
    //     }
    //   }
    // },
    convertTreeData() {
      this.setTreeCheckeboxStatus(false, this.treeList);
      console.log("this.currentStatus:"+this.currentStatus)
      if (this.currentStatus === "user" || this.currentStatus === "system") {
        this.setTreeCheckeboxStatus(true, this.treeList);
      } else if (this.currentStatus === "add") {
        // let index = this.treeList[0].children.findIndex(item => item.id === 2);
        // let childIndex = this.treeList[0].children[index].children.findIndex(item => item.id === 33);
        // this.treeList[0].children[index].disabled = true;
      }
    },
    setTreeCheckeboxStatus(status, list) {
      if (list && list.length) {
        for (let index in list) {
          list[index].disabled = status;
          this.setTreeCheckeboxStatus(status, list[index].children);
        }
      }
    },
    /**
     * 取消按钮事件
     */
    cancelAddRole() {
      this.$emit("cancelAddRole");
    },
    /**
     * 保存按钮事件
     */
    addRoleHandle() {
      let roleList = this.$refs.roleTree.getCheckedKeys().filter(key => key != 0);
      roleList.push(...this.$refs.roleTree.getHalfCheckedKeys().filter(key => key != 0));
      if (roleList.length === 0) {
        this.$message.warning("请至少选择一个权限");
        return;
      }
      this.$emit("addRoleHandle", {
        roleName: this.roleInfoData.roleName,
        roleDesc: this.roleInfoData.roleDesc,
        funcIdList: roleList
      });
    },
    /**
     * 点击编辑按钮，将页面的状态修改为 add
     */
    editRoleDetail() {
      this.$emit("update:currentStatus", "add");
    }
  },
  created() {
    this.getAllTreeData();
  }
}
</script>

<style lang="less" scoped>
.flex-box {
  display: flex;
  align-items: center;
}

.role-info-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  color: rgba(255, 255, 255, 0.9);

  .role-detail-headline {
    font-size: clamp(17px, 1.6vw, 19px);
    font-weight: 600;
    letter-spacing: 0.07em;
    color: rgba(255, 255, 255, 0.92);
  }

  .role-info-title {
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 26px;
    padding: 4px 4px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.09);
    font-size: 16px;
    font-weight: 600;

    .role-info-switch {
      margin-right: 10px;
    }

    > .flex-box:last-child {
      font-size: 13px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.55);
    }
  }

  .role-info-detail {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .role-detail-inner {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
  }

  .role-basic-panel {
    flex-shrink: 0;
    padding: 20px 22px 22px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.14);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  }

  .role-panel-caption {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 18px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.14em;
    color: rgba(255, 255, 255, 0.42);

    &::before {
      content: "";
      flex-shrink: 0;
      width: 3px;
      height: 13px;
      border-radius: 2px;
      background: linear-gradient(180deg, #47e09c 0%, #2ecd81 100%);
      box-shadow: 0 0 12px rgba(46, 205, 129, 0.22);
    }
  }

  .authorization-list .role-panel-caption {
    margin-bottom: 14px;
  }

  .role-basic-panel .role-panel-caption {
    margin-bottom: 18px;
  }

  .role-basic-panel .margin_bottom_12:last-child {
    margin-bottom: 0;
  }

  .field-row {
    align-items: flex-start;

    .field-label {
      padding-top: 12px;
    }
  }

  .field-label {
    flex-shrink: 0;
    width: 88px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
  }

  .input {
    flex: 1;
    max-width: 480px;
    min-width: 200px;
  }

  .authorization-list {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 20px 22px 22px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.14);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);

    .authorization-tree-wrap {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding: 14px 16px;
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.07);
      background: rgba(0, 0, 0, 0.18);

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.12);
        border-radius: 6px;
      }
    }
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    background: rgba(0, 0, 0, 0.18);
    border-color: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.45);
  }

  /deep/ .input .el-input__inner {
    height: 42px;
    line-height: 42px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.18);
    color: rgba(255, 255, 255, 0.9);

    &::placeholder {
      color: rgba(255, 255, 255, 0.32);
    }

    &:focus {
      border-color: rgba(46, 205, 129, 0.5);
    }
  }

  /deep/ .el-tree {
    background: transparent;
    color: rgba(255, 255, 255, 0.85);
  }

  /deep/ .el-tree-node__content:hover {
    background: rgba(255, 255, 255, 0.06) !important;
  }

  /deep/ .el-tree-node:focus > .el-tree-node__content {
    background: rgba(255, 255, 255, 0.04) !important;
  }

  /deep/ .el-checkbox__inner {
    border-color: rgba(255, 255, 255, 0.25);
    background: rgba(0, 0, 0, 0.2);
  }

  /deep/ .el-tree-node__content {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  /deep/ .el-tree {
    > .el-tree-node {
      > .el-tree-node__children {
        .el-tree-node:not(:last-child) {
          .el-tree-node__children {
            .el-tree-node__content {
              margin-left: 20px;

              .el-checkbox {
                display: block;
              }
            }
          }
        }
      }
    }
  }

  /deep/ .el-tree {
    > .el-tree-node {
      > .el-tree-node__content {
        margin-left: 42px;

        > .expanded {
          display: none;
        }

        > .el-tree-node__expand-icon {
          display: none;
        }
      }
    }
  }

  .margin_right_24 {
    margin-right: 24px;
  }

  .margin_bottom_12 {
    margin-bottom: 14px;
  }

  .role-info-footer {
    flex-shrink: 0;
    margin-top: auto;
    padding-top: 22px;
    border-top: 1px solid rgba(255, 255, 255, 0.09);
  }

  .role-info-footer-btns {
    display: flex;
    justify-content: flex-end;
    gap: 14px;
    flex-wrap: wrap;
  }

  .role-btn-primary {
    height: 42px;
    padding: 0 26px;
    font-weight: 500;
    border-radius: 10px;
    background-color: #2ecd81 !important;
    border-color: #2ecd81 !important;
    color: #fff !important;

    &:hover,
    &:focus {
      background-color: #26b872 !important;
      border-color: #26b872 !important;
    }
  }

  .role-btn-ghost {
    height: 42px;
    padding: 0 26px;
    border-radius: 10px;
    background: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.22) !important;
    color: rgba(255, 255, 255, 0.85) !important;

    &:hover,
    &:focus {
      border-color: rgba(255, 255, 255, 0.35) !important;
      color: #fff !important;
      background: rgba(255, 255, 255, 0.06) !important;
    }
  }
}

.role-info-content /deep/ .el-switch.is-checked .el-switch__core {
  border-color: #2ecd81;
  background-color: #2ecd81;
}

.role-info-content /deep/ .el-tree .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #2ecd81;
  background-color: #2ecd81;
}

.role-info-content /deep/ .el-tree .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #2ecd81;
  background-color: #2ecd81;
}
</style>
